import uniqBy from 'lodash/uniqBy';
import { put, fork, take, select } from 'redux-saga/effects';
import { takeFetch } from 'redux/helpers';
import * as serviceActions from '../../../../services/actions';
import * as actions from './actions';


function* getSprintListSuccess() {
  const { success } = yield takeFetch(serviceActions.api.configuration.sprint.GET_LIST);
  if (success) {
    const teamOptions = success.data.teams
    const selectedTeam = teamOptions[0];
    yield put(actions.init.end({ sprintList: success.data.sprints, teamOptions, selectedTeam }));
    yield put(actions.invalidate.begin());
  }
}

function* init() {
  while (true) {
    let { projectId } = yield take(actions.INIT.BEGIN);
    if (!projectId) {
      const sprint = yield select(state => state.configuration.project.editor.sprint);
      projectId = sprint.projectId;
    }
    yield put(serviceActions.api.configuration.sprint.getList.request({
      projectId,
    }));
    yield fork(getSprintListSuccess);
  }
}

function* refresh() {
  while (true) {
    yield take(actions.REFRESH);
    const { projectId } = yield select(state => state.configuration.project.editor.sprint);
    yield put(serviceActions.api.configuration.sprint.getList.request({
      projectId,
    }));
    yield fork(getSprintListSuccess);
  }
}

function* invalidate() {
  while (true) {
    yield take(actions.INVALIDATE.BEGIN);
    const { selectedTeam, sprintList } = yield select(state => state.configuration.project.editor.sprint);
    const items = sprintList.filter(val => val.teamId === selectedTeam.id);
    yield put(actions.invalidate.end({ items }));
  }
}

function* setTeam() {
  while (true) {
    yield take(actions.SET_TEAM);
    yield put(actions.invalidate.begin());
  }
}

function* edit() {
  while (true) {
    yield take(actions.EDIT);
    $('#sprint-in-project-viewer-popup').modal('show');
  }
}

export default function* team() {
  yield fork(init);
  yield fork(refresh);
  yield fork(invalidate);
  yield fork(setTeam);
  yield fork(edit);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/sprint/saga.js